// Lib
import { createSelector, createStructuredSelector } from 'reselect';

// Selectors
import { popupOpenSelector } from '../../../../../../../components/popupPanel/popupOpenSelector';
import { getElements } from '../../../../../../../element/selectors/elementSelector';
import {
    currentBoardHasPublicEditPermissionsSelector,
    currentBoardSpecificUserPermissionsSelector,
    currentBoardUserPermissionsSelector,
} from '../../../../../../../utils/permissions/elementPermissionsSelector';

const userPopupOpenSelector = (state, { popupId }) => popupOpenSelector(popupId)(state);

const userAccessSelector = createSelector(
    (state, props) => props.userId,
    (state, props) => props.currentBoardEditors,
    (userId, currentBoardEditors) => currentBoardEditors.find((entry) => entry.userId === userId),
);

const sharedBoardSelector = createSelector(
    userAccessSelector,
    getElements,
    (userAccess, elements) => userAccess && elements.get(userAccess.sharedBoardId),
);

export default createStructuredSelector({
    popupOpen: userPopupOpenSelector,
    userAccess: userAccessSelector,
    sharedBoard: sharedBoardSelector,
    userPermissions: currentBoardUserPermissionsSelector,
    specificUserPermissions: currentBoardSpecificUserPermissionsSelector,
    hasPublicEditPermissions: currentBoardHasPublicEditPermissionsSelector,
});
